"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.StaggerAnimationType = exports.AnimationType = void 0;
exports.getAnimationType = getAnimationType;
exports.getModeType = getModeType;
var _react = require("@linaria/react");
/* eslint-disable complexity */
/* eslint-disable max-len */

const animationValues = {
  movement: {
    100: '15%',
    200: '25%',
    300: '35%',
    400: '55%',
    500: '75%'
  },
  movementFixed: {
    100: '0.25rem',
    200: '0.75rem',
    300: '1.25rem',
    400: '1.75rem',
    500: '2.25rem'
  },
  scaleUp: {
    100: '0.985',
    200: '0.925',
    300: '0.85',
    400: '0.775',
    500: '0.7'
  },
  scaleDown: {
    100: '1.015',
    200: '1.075',
    300: '1.15',
    400: '1.225',
    500: '1.3'
  }
};
function getModeType(props) {
  let mode;
  switch (props) {
    case 'swift':
      mode = `cubic-bezier(0.22, 1, 0.36, 1)`;
      break;
    case 'fluid':
      mode = `cubic-bezier(0.25, 0.61, 0.35, 1)`;
      break;
    case 'rebound':
      mode = `cubic-bezier(0.22, 1.42, 0.64, 1)`;
      break;
    default:
      mode = `cubic-bezier(0.25, 0.61, 0.35, 1)`;
      break;
  }
  return mode;
}
function getAnimationValue(type, intensity) {
  // Filter each animation values by type and return with intensity
  const filtered = [type]?.reduce((obj, key) => ({
    ...obj,
    settings: animationValues[key]
  }), {});
  return filtered?.settings[intensity];
}
function getAnimationType(props, intensity = '100') {
  let animationType;
  switch (props) {
    case 'appear':
      animationType = `translate3d(0, 0, 0)`;
      break;
    case 'moveUp':
      animationType = `translate3d(0, ${getAnimationValue('movement', `${intensity}`)}, 0)`;
      break;
    case 'moveDown':
      animationType = `translate3d(0, -${getAnimationValue('movement', `${intensity}`)}, 0)`;
      break;
    case 'moveLeft':
      animationType = `translate3d(${getAnimationValue('movement', `${intensity}`)}, 0, 0)`;
      break;
    case 'moveRight':
      animationType = `translate3d(-${getAnimationValue('movement', `${intensity}`)}, 0, 0)`;
      break;
    case 'moveUpFixed':
      animationType = `translate3d(0, ${getAnimationValue('movementFixed', `${intensity}`)}, 0)`;
      break;
    case 'moveDownFixed':
      animationType = `translate3d(0, -${getAnimationValue('movementFixed', `${intensity}`)}, 0)`;
      break;
    case 'moveLeftFixed':
      animationType = `translate3d(${getAnimationValue('movementFixed', `${intensity}`)}, 0, 0)`;
      break;
    case 'moveRightFixed':
      animationType = `translate3d(-${getAnimationValue('movementFixed', `${intensity}`)}, 0, 0)`;
      break;
    case 'scaleUp':
      animationType = `scale(${getAnimationValue('scaleUp', `${intensity}`)})`;
      break;
    case 'scaleDown':
      animationType = `scale(${getAnimationValue('scaleDown', `${intensity}`)})`;
      break;
    default:
      animationType = `translate3d(0, 0, 0)`;
      break;
  }
  return animationType;
}

// eslint-disable-next-line no-unused-vars
function generateStagger(delayChildren) {
  let staggeredStyles = '';
  for (let i = 0; i < 20; i++) {
    staggeredStyles += `
      &:nth-child(${i}) {
        animation-delay: calc(${delayChildren}s * ${i});
      }
    `;
  }
  return staggeredStyles;
}
const AnimationType = exports.AnimationType = /*#__PURE__*/(0, _react.styled)("div")({
  name: "AnimationType",
  class: "pl-a18osifv",
  vars: {
    "a18osifv-0": [({
      intensity,
      intensityMultiplier = 4
    }) => `${Math.round(Number(intensity) * intensityMultiplier)}ms`],
    "a18osifv-1": [({
      mode
    }) => `${getModeType(mode)}`],
    "a18osifv-2": [({
      delay
    }) => delay + 's'],
    "a18osifv-3": [({
      variant,
      intensity
    }) => `${getAnimationType(variant, intensity)}`],
    "a18osifv-4": [({
      intensity
    }) => `${getAnimationType('appear', intensity)}`]
  }
});

// Below is the static equivalent of generateStagger(0.125)
const StaggeredChildrenStatic = `
  &:nth-child(0) {
    animation-delay: calc(0.125s * 0);
  }

  &:nth-child(1) {
    animation-delay: calc(0.125s * 1);
  }

  &:nth-child(2) {
    animation-delay: calc(0.125s * 2);
  }

  &:nth-child(3) {
    animation-delay: calc(0.125s * 3);
  }

  &:nth-child(4) {
    animation-delay: calc(0.125s * 4);
  }

  &:nth-child(5) {
    animation-delay: calc(0.125s * 5);
  }

  &:nth-child(6) {
    animation-delay: calc(0.125s * 6);
  }

  &:nth-child(7) {
    animation-delay: calc(0.125s * 7);
  }

  &:nth-child(8) {
    animation-delay: calc(0.125s * 8);
  }

  &:nth-child(9) {
    animation-delay: calc(0.125s * 9);
  }

  &:nth-child(10) {
    animation-delay: calc(0.125s * 10);
  }

  &:nth-child(11) {
    animation-delay: calc(0.125s * 11);
  }

  &:nth-child(12) {
    animation-delay: calc(0.125s * 12);
  }

  &:nth-child(13) {
    animation-delay: calc(0.125s * 13);
  }

  &:nth-child(14) {
    animation-delay: calc(0.125s * 14);
  }

  &:nth-child(15) {
    animation-delay: calc(0.125s * 15);
  }

  &:nth-child(16) {
    animation-delay: calc(0.125s * 16);
  }

  &:nth-child(17) {
    animation-delay: calc(0.125s * 17);
  }

  &:nth-child(18) {
    animation-delay: calc(0.125s * 18);
  }

  &:nth-child(19) {
    animation-delay: calc(0.125s * 19);
  }
`;
const StaggerAnimationType = exports.StaggerAnimationType = /*#__PURE__*/(0, _react.styled)("div")({
  name: "StaggerAnimationType",
  class: "pl-sd5obfi",
  vars: {
    "sd5obfi-0": [({
      intensity,
      intensityMultiplier = 4
    }) => `${Math.round(Number(intensity) * intensityMultiplier)}ms`],
    "sd5obfi-1": [({
      mode
    }) => `${getModeType(mode)}`],
    "sd5obfi-5": [({
      variant,
      intensity
    }) => `${getAnimationType(variant, intensity)}`],
    "sd5obfi-6": [({
      intensity
    }) => `${getAnimationType('appear', intensity)}`]
  }
});